import { TranslateHelper } from '@app/_helpers';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { BlockHeaderGroup } from '@app/_interfaces/block-header-group';
import { DirectionService } from '@app/_services/direction.service';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { products } from 'src/fake-server/database/products';
import { BlockProductCarouselService } from './block-products-carousel.service';
import { ProductCardNewComponent } from '../../shared/components/product-card-new/product-card-new.component';
import { OwlPreventClickDirective } from '../../shared/directives/owl-prevent-click.directive';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { BlockHeaderComponent } from './components/block-header/block-header.component';
import { NgClass, NgFor } from '@angular/common';

@Component({
    selector: 'app-block-products-carousel',
    templateUrl: './block-products-carousel.component.html',
    styleUrls: ['./block-products-carousel.component.scss'],
    providers: [BlockProductCarouselService, TranslateHelper],
    standalone: true,
    imports: [NgClass, BlockHeaderComponent, CarouselModule, OwlPreventClickDirective, NgFor, ProductCardNewComponent]
})

export class BlockProductsCarouselComponent implements OnInit, OnChanges {

    constructor(public blockProductCarouselService: BlockProductCarouselService,
                private direction: DirectionService,
                public translate: TranslateService,
                public translateHelper:TranslateHelper
    ) { }

    carouselOptions;
    ngOnInit(): void {
        if (!_.isEmpty(this.products) && _.isArray(this.products)) {
            this.columns = [];

            if (this.products && this.rows > 0) {
                const products = this.products.slice();

                while (products.length > 0) {
                    this.columns.push(products.splice(0, this.rows));
                }
            }
            this.blockProductCarouselService.changeProducts(this.products);
            this.products = this.blockProductCarouselService.carouselProductsValue;
            /// if there are headers plug them in
            if (!_.isEmpty(this.headers) && _.isArray(this.headers)) {
                this.blockProductCarouselService.changeHeaders(this.headers);
                this.blockProductCarouselService.changeSelectedHeader(this.headers[0]);
            }
        } else {
            /// get products using the headers id
            if (!_.isEmpty(this.headers) && _.isArray(this.headers)) {
                this.blockProductCarouselService.changeHeaders(this.headers);
            }
        }

       this.carouselOptions =  Object.assign({}, this.carouselDefaultOptions, this.carouselOptionsByLayout[this.layout]);
    }

    @Input() name;
    @Input() layout: 'grid-4' | 'grid-4-sm' | 'grid-5' | 'horizontal' | 'custom' = 'custom';
    @Input() rows = 1;
    @Input() products: any[] = [];
    @Input() headers: any[] = [];
    @Input() withSidebar = false;
    @Input() loading = false;

    //@Output() groupChange: EventEmitter<BlockHeaderGroup> = new EventEmitter();

    columns: any[][] = [];

    carouselDefaultOptions: any = {
        lazyLoad: true,
        items: 4,
        margin: 14,
        nav: false,
        dots: false,
        loop: true,
        skip_validateItems: true,
        stagePadding: 1,
        rtl: this.direction.isRTL()
    };

    carouselOptionsByLayout: any = {
        'grid-4': {
            responsive: {
                1110: { items: 3, margin: 12 },
                930: { items: 3, margin: 8 },
                690: { items: 2, margin: 6 },
                400: { items: 1, margin: 0 },
                0: { items: 1 }
            }
        },
        'grid-4-sm': {
            responsive: {
                820: { items: 3, margin: 8 },
                640: { items: 2, margin: 6 },
                400: { items: 1, margin: 0 },
                0: { items: 1 }
            }
        },
        'grid-5': {
            responsive: {
                1110: { items: 4, margin: 12 },
                930: { items: 3, margin: 8 },
                690: { items: 2, margin: 8 },
                400: { items: 1, margin: 0 },
                0: { items: 1 }
            }
        },
        'custom': {
            responsive: {
                1300: { items: 4, margin: 12 },
                1050: { items: 3, margin: 8 },
                690: { items: 2, margin: 8 },
                0: { items: 1 }
            }
        },
        'grid': {
            responsive: {
                1300: { items: 3, margin: 12 },
                1050: { items: 2, margin: 8 },
                690: { items: 2, margin: 8 },
                0: { items: 1 }
            }
        },
        'card-2': {
            responsive: {
                1050: { items: 4, margin: 40 },
                690: { items: 3, margin: 8 },
                150: { items: 2 },
                0: { items: 1 }
            }
        },
        'card-3': {
            responsive: {
                1050: { items: 3, margin: 20 },
                690: { items: 2, margin: 8 },
                150: { items: 1 },
                0: { items: 1 }
            }
        },
        'horizontal': {
            items: 3,
            responsive: {
                1110: { items: 3, margin: 12 },
                930: { items: 3, margin: 8 },
                690: { items: 2, margin: 6 },
                0: { items: 1 }
            }
        }
    };





    ngOnChanges(changes: SimpleChanges): void {
        const properties = Object.keys(changes);

        if (properties.includes('products') || properties.includes('row')) {
            this.columns = [];

            if (this.products && this.rows > 0) {
                const products = this.products.slice();

                while (products.length > 0) {
                    this.columns.push(products.splice(0, this.rows));
                }
            }
        }
    }

    groupChange(group): void {
        //this.loading = true;
        this.products = this.products.splice(0, 1)
    }
}
